<template>
  <div>
    <Slide
      id="hamburgerMenu"
      :closeOnNavigation="true"
      @openMenu="this.handleOpenMenu"
      @closeMenu="this.handleCloseMenu"
    >
      <a @click="routeTo('/Home')"> Home </a>
      <a @click="routeTo('/Beauty')"> Beauty </a>
      <a @click="routeTo('/Arrangement')"> Arrangementen </a>
      <a @click="routeTo('/Energetisch')"> Energetisch </a>
      <a @click="routeTo('/Coaching')"> Coaching </a>
      <a @click="routeTo('/YonKa')"> Yon-Ka </a>
      <a @click="routeTo('/Contact')"> Contact </a>
    </Slide>
    <nav
      id="defaultNavbar"
      class="navbar"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navItemHolder">
        <a
          name="home"
          tabindex="0"
          @click="routeTo('/Home')"
          class="navbarItem"
        >
          Home
        </a>

        <a name="beauty" @click="routeTo('/Beauty')" class="navbarItem">
          Beauty
        </a>
        <a
          name="Arrangement"
          @click="routeTo('/Arrangement')"
          class="navbarItem"
        >
          Arrangementen
        </a>
        <a
          name="Energetisch"
          @click="routeTo('/Energetisch')"
          class="navbarItem"
        >
          Energetisch
        </a>
        <a name="Coaching" @click="routeTo('/Coaching')" class="navbarItem">
          Coaching
        </a>
        <a name="YonKa" @click="routeTo('/YonKa')" class="navbarItem">
          Yon-Ka
        </a>
        <a name="contact" @click="routeTo('/Contact')" class="navbarItem">
          Contact
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
 import { Slide } from 'vue-burger-menu';
export default {
  name: 'Navbar',
  components: {
      Slide
  },
  methods: {
     routeTo(path) {
      this.$router.push(path).catch(() => {});
    },
     handleOpenMenu(){
      var x = document.getElementsByClassName("bm-burger-button")[0];
      x.style.display = "none";
    },
    handleCloseMenu(){
      var x = document.getElementsByClassName("bm-burger-button")[0];
      x.style.display = "block";
    } 
  }
};
</script>

<style lang="scss">
#hamburgerMenu {
  display: none;
  position: fixed;
  z-index: 5;
  height: 5vh;
  width: 5vh;
  top: 0;
  padding-left: 16px;

  .bm-burger-button {
    left: 0;
  }
  .bm-burger-bars {
    background-color: var(--caramel);
  }
  .bm-cross {
    background: var(--dark);
  }
  .bm-menu {
    background-color: var(--caramel);
  }

  .bm-item-list {
    display: flex;
    flex-direction: column;
    height: 100%;
    a {
      color: var(--white);
      font-size: 1em;
      cursor: pointer;
    }
  }
}

.navbar {
  width: 100%;
  height: 6vh;
  min-height: 3vh;
  background-color: var(--caramel);

  .navItemHolder {
    height: 100%;
    display: flex;
    align-items: stretch;
    justify-content: center;

    .navbarItem {
      display: flex;
      align-items: center;
      padding: 0 2.5vw 0 2.5vw;
      color: var(--white);
      transition: 0.3s;

      &:hover {
        cursor: pointer;
        background-color: var(--cookie);
      }
    }
  }
}

@media only screen and (max-width: 850px) {
  #defaultNavbar {
    display: none;
  }

  #hamburgerMenu {
    display: inline;
  }
}
</style>
